import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {FacadeService} from "../../../../shared/service-facade/facade.service";
import {SettingsEnum} from "../../../../shared/model/settings.enum";

@Component({
  selector: 'app-security-dialog',
  templateUrl: './security-dialog.component.html',
  styleUrls: ['./security-dialog.component.scss']
})
export class SecurityDialogComponent implements OnInit, AfterViewInit {
  public privacyUrl = "";
  secureHeadingId: string = '';

  constructor(
    public dialogRef: MatDialogRef<SecurityDialogComponent>,
    private facadeService: FacadeService,
  ) { }
  
  ngOnInit(): void {
    this.privacyUrl = this.facadeService.getStorageItem(SettingsEnum.PrivacyPolicyUrl)
  }

  ngAfterViewInit(): void {
    const ele: any = document.querySelector('mat-dialog-container');
    //settimeout used because aria-labelledby is getting render after sometimes
    setTimeout(() => {
      const dynamicElementTitle: any = ele.getAttribute('aria-labelledby');
      if(ele && dynamicElementTitle) {
        this.secureHeadingId = dynamicElementTitle;
      }
    }, 0);
  }
}
